import { combineReducers } from 'redux'
import assetInfo from './assets'
import currencyInfo from './currencies'
import fireInfo from './fire'
import liabilityInfo from './liabilities'
import netWorthInfo from './networth'
import settingsInfo from './settings'
import userInfo from './user'

export default combineReducers({
  assetInfo,
  currencyInfo,
  fireInfo,
  liabilityInfo,
  netWorthInfo,
  settingsInfo,
  userInfo
})
